import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import Home from "./pages/Home/Home";
import Attributions from "./pages/Attributions/Attributions";
import Collaboration from "./pages/Collaboration/Collaboration";
import Contribution from "./pages/Contribution/Contribution";
import Description from "./pages/Description/Description";
import Design from "./pages/Design/Design";
import Engineering from "./pages/Engineering/Engineering";
import Entrepreneurship from "./pages/Entrepreneurship/Entrepreneurship";
import Integrated from "./pages/Integrated/Integrated";
import Medal from "./pages/Medal/Medal";
import Members from "./pages/Members/Members";
import Model from "./pages/Model/Model";
import Notebook from "./pages/Notebook/Notebook";
import Proof from "./pages/Proof/Proof";
import Safety from "./pages/Safety/Safety";
import Software from "./pages/Software/Software";

function App() {
  return (
    <SnackbarProvider
      maxSnack={3}
      style={{
        backgroundColor: "#ef5350",
        fontSize: "24px",
        fontWeight: "600",
        borderRadius: "10px",
        padding: "20px",
      }}
    >
      <div>
        <BrowserRouter>
          <Routes>
            <Route
              exact
              path="/sysu-software/attributions"
              element={<Attributions />}
            />
            <Route exact path="/sysu-software" element={<Home />} />
            <Route
              exact
              path="/sysu-software/collaboration"
              element={<Collaboration />}
            />
            <Route
              exact
              path="/sysu-software/contribution"
              element={<Contribution />}
            />
            <Route
              exact
              path="/sysu-software/description"
              element={<Description />}
            />
            <Route exact path="/sysu-software/design" element={<Design />} />
            <Route
              exact
              path="/sysu-software/engineering"
              element={<Engineering />}
            />
            <Route
              exact
              path="/sysu-software/entrepreneurship"
              element={<Entrepreneurship />}
            />
            <Route
              exact
              path="/sysu-software/human-practices"
              element={<Integrated />}
            />
            <Route exact path="/sysu-software/medal" element={<Medal />} />
            <Route exact path="/sysu-software/members" element={<Members />} />
            <Route exact path="/sysu-software/model" element={<Model />} />
            <Route
              exact
              path="/sysu-software/notebook"
              element={<Notebook />}
            />
            <Route
              exact
              path="/sysu-software/proof-of-concept"
              element={<Proof />}
            />
            <Route exact path="/sysu-software/safety" element={<Safety />} />
            <Route
              exact
              path="/sysu-software/software"
              element={<Software />}
            />
          </Routes>
        </BrowserRouter>
      </div>
    </SnackbarProvider>
  );
}

export default App;
